import React from 'react'
import ScrollWrap from '../components/ScrollWrap'
import Navbar from '../components/Navbar'
import MainWrap from '../components/MainWrap'
import Overlay from '../components/Overlay'
import ContactFormWrap from '../components/ContactFormWrap'
import FundamentalCourses2 from '../components/FundamentalCourses2'
import TrendingData from '../data/TrendingData'
import CounterArea from '../components/CounterArea'
import Enroll from '../components/Enroll'
import RelatedCourses from '../components/RelatedCourses'
import Footer from '../components/Footer'
import SlickSlider2 from '../components/SlickSlider2'
import { SlickTrendingData } from '../data/SlickSliderData'
import { CounterData2 } from '../data/CounterData'
import { EnrollData3 } from '../data/EnrollData'
import LoginAnchor from '../components/LoginAnchor'
import ContactAnchor from '../components/ContactAnchor'

export default function TrendingModule() {
    return (
        <>
            <ContactAnchor />
            <LoginAnchor />
            <ScrollWrap />
            <Navbar />
            <MainWrap />
            <ContactFormWrap />
            <Overlay />
            <SlickSlider2 data={SlickTrendingData}/>
            <FundamentalCourses2 data={TrendingData}/>
            <CounterArea data={CounterData2}/>
            <Enroll data={EnrollData3} />
            <RelatedCourses />
            <Footer />
        </>
    )
}
